import axios from 'axios';

const Http = axios.create({
  baseURL: 'https://sac.sistemaspower.com.br/sacapi/v1/'
  //baseURL: 'https://sac.sistemaspower.com.br/sacapi-homologacao/v1/'
  //baseURL: 'http://127.0.0.1:3333/v1/'
});

export default Http;
